// extracted by mini-css-extract-plugin
export var gif = "_ht-0";